export const movementOptions = [
  { key: 'PCPL', value: 'PCPL', text: 'PCPL' },
  { key: 'Party', value: 'Party', text: 'Party' },
  {
    key: 'American Museum of Moving Image',
    value: 'American Museum of Moving Image',
    text: 'American Museum of Moving Image',
  },
  { key: 'Block Cinema', value: 'Block Cinema', text: 'Block Cinema' },
  {
    key: 'Academy Film Archive',
    value: 'Academy Film Archive',
    text: 'Academy Film Archive',
  },
  {
    key: 'Preferred Media - Floyd (Chase Schulte)',
    value: 'Preferred Media - Floyd (Chase Schulte)',
    text: 'Preferred Media - Floyd (Chase Schulte)',
  },
  {
    key: 'Paramount Screening Room 5, Studio Theatre',
    value: 'Paramount Screening Room 5, Studio Theatre',
    text: 'Paramount Screening Room 5, Studio Theatre',
  },
  {
    key: 'BRITISH FILM INSTITUTE - Lorraine Salter',
    value: 'BRITISH FILM INSTITUTE - Lorraine Salter',
    text: 'BRITISH FILM INSTITUTE - Lorraine Salter',
  },
  {
    key: 'Los Angeles County Museum of Art',
    value: 'Los Angeles County Museum of Art',
    text: 'Los Angeles County Museum of Art',
  },
  {
    key: 'WE OWN THE NIGHT - Production Offices',
    value: 'WE OWN THE NIGHT - Production Offices',
    text: 'WE OWN THE NIGHT - Production Offices',
  },
  {
    key: 'Museum of Modern Art - NYC',
    value: 'Museum of Modern Art - NYC',
    text: 'Museum of Modern Art - NYC',
  },
  {
    key: 'Triage Center c/o Iron Mountain',
    value: 'Triage Center c/o Iron Mountain',
    text: 'Triage Center c/o Iron Mountain',
  },
  {
    key: 'ARCHIVE Vault D',
    value: 'ARCHIVE Vault D',
    text: 'ARCHIVE Vault D',
  },
  { key: 'PRO-TEK', value: 'PRO-TEK', text: 'PRO-TEK' },
];
